<script>
import Endpoints from '../../components/common/Endpoints';
import Common from '../../components/common/Common';
import Request from '../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        payload.domain = Endpoints.domain;//nao remover, usado para apresentar a foto

         setTimeout(async function(){
            let response = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.banners.list}`);
            payload.items = response.data.results;
        }, 100);
        
    },
    methods:{
        filter: function(){
            this.items = [];
            Request.do(this, 'GET', Request.getDefaultHeader(this), null, `${Endpoints.banners.list}`,
            (response)=>{//SUCCESS CALLBACK
                this.items = response.results;
                console.log(response.results)
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
